export enum CaseRowsViewMode {
  Basic,
  Advanced,
  Custom,
  Detailed
}
